module.exports = __webpack_public_path__ + "img/fullScreen.561142bc.svg";